import { render, staticRenderFns } from "./SOV5Detailed.vue?vue&type=template&id=9a87550c&scoped=true"
import script from "./SOV5Detailed.vue?vue&type=script&lang=js"
export * from "./SOV5Detailed.vue?vue&type=script&lang=js"
import style0 from "./SOV5Detailed.vue?vue&type=style&index=0&id=9a87550c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a87550c",
  null
  
)

export default component.exports